import { render, staticRenderFns } from "./CreatePaymentKasbonCombination.vue?vue&type=template&id=39cb7b0e"
import script from "./CreatePaymentKasbonCombination.vue?vue&type=script&lang=js"
export * from "./CreatePaymentKasbonCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports